import { CircleSize, useCircleSize } from "../LayoutProvider";
import React, { PropsWithChildren } from "react";

import { Box } from "./Box";
import { BoxProps } from "./BoxProps";
import { ViewStyle } from "react-native";
import { useBoxStyle } from "./useBoxStyle";

export function Circle(
  props: PropsWithChildren<
    Pick<BoxProps, "borderColor" | "color" | "shadow"> & {
      size: CircleSize;
      borderWidth?: number;
      allowGrow?: boolean;
    } & { style?: ViewStyle }
  >
) {
  const { size, children, borderWidth, style, ...boxProps } = props;
  const boxStyles = useBoxStyle(boxProps);
  const absSize = useCircleSize(size);
  const sizeStyle = props.allowGrow
    ? {
        minHeight: absSize,
        minWidth: absSize,
      }
    : {
        height: absSize,
        width: absSize,
      };
  return (
    <Box
      style={[
        boxStyles,
        {
          flexDirection: "column",
          alignItems: "center",
          borderWidth,
          justifyContent: "center",
          ...sizeStyle,
          borderRadius: Math.ceil(absSize / 2),
          ...style,
        },
      ]}
    >
      {children}
    </Box>
  );
}

function AbsoluteCircle(
  props: PropsWithChildren<
    Pick<BoxProps, "borderColor" | "color" | "shadow"> & {
      absoluteSize: number;
      borderWidth?: number;
      allowGrow?: boolean;
    } & { style?: ViewStyle }
  >
) {
  const { absoluteSize, children, borderWidth, style, ...boxProps } = props;
  const boxStyles = useBoxStyle(boxProps);

  const absSize = props.absoluteSize;
  const sizeStyle = props.allowGrow
    ? {
        minHeight: absSize,
        minWidth: absSize,
      }
    : {
        height: absSize,
        width: absSize,
      };
  return (
    <Box
      style={[
        boxStyles,
        {
          flexDirection: "column",
          alignItems: "center",
          borderWidth,
          justifyContent: "center",
          ...sizeStyle,
          borderRadius: Math.ceil(absSize / 2),
          ...style,
        },
      ]}
    >
      {children}
    </Box>
  );
}
